<template>
  <div v-if="message">
    <span v-html="message"></span>
    <button type="button" class="close" aria-label="Close" @click="close">
      <i class="fas fa-times" title="Close" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'dt-message',
  props: {
    value: String
  },
  computed: {
    message: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    close() {
      this.message = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utilities/form/dt-message.vue